import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/formSheet.css";

const FinancialModal = ({ courseName, setActive }) => {
  return (
    <>
      <div className="financial-popup">
        <div className="financial-popup-content">
          <h3>Application for financial aid can take up to 48hrs to review</h3>
          <p>
            if approved you will be eligible to recieve up to 70% off the
            regular price
          </p>
          <div className="selected-course">
            <p>selected course</p>
            <div className="course-content">{courseName}</div>
          </div>
          <Link to="/financial-aid">
            <button className="btn2 enroll-btn ln">Apply</button>
          </Link>
          <button className="btn2 ln" onClick={() => setActive(false)}>
            Discard
          </button>
        </div>
      </div>
    </>
  );
};

export default FinancialModal;
